import { TextCutter } from '@anytag/shared-atoms';
import { InfluencerAvatar } from '@anytag/shared-molecules';
import { cn } from '@anytag/shared-utils';

export interface AnalyticsComparePostsAccountProps {
  className?: string;
  account: { name?: string | null; avatar?: string | null };
}

export const AnalyticsComparePostsAccount = ({ account, className }: AnalyticsComparePostsAccountProps) => (
  <div className={cn('box-border flex w-40 items-center', className)}>
    <InfluencerAvatar src={account?.avatar} size="40px" className="mr-2 rounded-full" />
    <TextCutter className="text-base leading-4" text={account?.name || '-'} lines={3} />
  </div>
);
